import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Box,
  Button,
  Divider,
  Drawer,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ExpandMore,
  moment,
} from "../../Collections/Imports";
import GlobalDateRangePicker from "../../Components/CommonComponents/GlobalDateRangePicker";
import "./style.css";
import GlobalMultiSelect from "../../Components/CommonComponents/GlobalMultiSelect";
import { useDispatch, useSelector } from "react-redux";
import { updateBuyersFilterData } from "../../Store/BuyerModule/filterSession";
import {
  useApiCallMutation,
  useGetApiCallQuery,
} from "../../Services/ApiCallService";
import {
  buyerModuleAPiENdPoints,
  coreAPIEndsPoints,
} from "../../Config/APIsEndpoints";
import { updateLabelOptions } from "../../Store/Global/LabelOptions";
import { updateManagerOptions } from "../../Store/Global/ManagerOptions";
import { updateTypeOptions } from "../../Store/Global/TypeOptions";
import { updateBuyesOptions } from "../../Store/Global/BuyersOptions";
import { click } from "@testing-library/user-event/dist/click";
import CustomButton from "../../Components/CommonComponents/GlobalButton";
import GlobalDropdown from "../../Components/CommonComponents/GlobalDropdown";
import {
  buyerNameOptions,
  labelOptionsData,
  typeOptionsData,
} from "../../Store/BuyerModule";
import { CampaignNameOptions } from "../../Store/CampaignModule";

const BuyerFilters = (props) => {
  const { setOpen, isOpen, defaultValues, isEditMode, defaultBuyers } = props;

  const [selectedDateFilter, setSelectedDateFilter] = useState({
    startDate: new Date("July 01, 2020"),
    endDate: new Date(),
    key: "selection",
  });

  const previousFilterData = useSelector(
    (state) => state?.buyersDataFilterSession?.filterData
  );

  const AllFilterLength = useSelector(
    (state) => state?.buyersDataFilterSession?.filterData
  );

  const buyersOptions = useSelector(
    (state) => state?.buyersData?.buyerAllOptions?.buyerNameOpt
  );

  const labelOpt = useSelector(
    (state) => state?.buyersData?.buyerAllOptions?.labelOpt
  );

  const typeOpt = useSelector(
    (state) => state?.buyersData?.buyerAllOptions?.typeOpt
  );

  const dispatch = useDispatch();

  const getLabelOptions = useGetApiCallQuery({
    endPoint: coreAPIEndsPoints.getLabel,
    method: "GET",
  });
  const getManagerOptions = useGetApiCallQuery({
    endPoint: coreAPIEndsPoints.getManager,
    method: "GET",
  });
  const getTypeOptions = useGetApiCallQuery({
    endPoint: coreAPIEndsPoints.getType,
    method: "GET",
  });
  const [GetAllbuyers, AllbuyersData] = useApiCallMutation();

  if (getManagerOptions?.isSuccess) {
    dispatch(updateManagerOptions(getManagerOptions?.data?.data));
  }

  const currentDate = new Date("July 01, 2020");

  useEffect(() => {
    GetAllbuyers({
      endPoint: buyerModuleAPiENdPoints.getAllbuyers,
      method: "POST",
      data: {
        data: {
          index: "All",
          itemPerIndex: "All",
          buyerNames: ["All"],
          labelIds: ["All"],
          typeIds: ["All"],
          status: "all",
          fromDate: currentDate,
          toDate: new Date(),
          // fromDate: moment(currentDate).toISOString(),
          // toDate: moment(new Date()).toISOString(),

          // fromDate:
          //   moment(dateRange[0].startDate).startOf("day").toISOString() || fromDate,
          // toDate:
          //   moment(dateRange[0]?.endDate).endOf("day").toISOString() || toDate,
        },
      },
    });
  }, []);

  useEffect(() => {
    if (AllbuyersData?.isSuccess && AllbuyersData?.data?.data?.buyers?.length) {
      const buyersOptions = AllbuyersData?.data?.data?.buyers.map((buyer) => {
        return { label: buyer?.buyerName, value: buyer?.buyerName };
      });
      // dispatch(updateBuyesOptions(buyersOptions));
      dispatch(buyerNameOptions(buyersOptions));
    }
  }, [AllbuyersData]);

  // debugger;
  useEffect(() => {
    if (
      getLabelOptions.isSuccess &&
      getLabelOptions?.data?.data?.label?.length
    ) {
      const labelOptions = getLabelOptions?.data?.data?.label.map((label) => {
        return { label: label?.label, value: label?.value };
      });

      dispatch(labelOptionsData(labelOptions));
    }
  }, [getLabelOptions]);

  useEffect(() => {
    if (getTypeOptions.isSuccess && getTypeOptions?.data?.data?.type) {
      const typeOptions = getTypeOptions?.data?.data?.type.map((type) => {
        return { label: type?.label, value: type?.value };
      });

      dispatch(typeOptionsData(typeOptions));
    }
  }, [getTypeOptions]);

  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      status: "All",
      buyerName: ["All"],
      label: ["All"],
      type: ["All"],
    },
    // resolver: yupResolver(validationSchema),
    mode: "all",
  });

  // const statusOptions = [
  //   { label: "Active", value: "true" },
  //   { label: "Disabled", value: "false" },
  // ];

  //Push new option All
  const AllOptions = { label: "All", id: 1, value: "All" };

  const [statusOptions, setStatusOptions] = useState([
    { label: "Active", value: "true" },
    { label: "Disabled", value: "false" },
  ]);
  // Pushing the AllOptions object into the statusOptions array
  useEffect(() => {
    setStatusOptions((prevOptions) => [AllOptions, ...prevOptions]);
  }, []);

  const [BuyerOptions, setBuyerOptions] = useState([]);
  const [LabelOptions, setLabelOptions] = useState([]);
  const [TypeOptions, setTypeOptions] = useState([]);

  // console.log("LabelOptions-----------LabelOptions", LabelOptions);
  // console.log("BuyerOptions-----------BuyerOptions", BuyerOptions);

  useEffect(() => {
    setBuyerOptions((prevOptions) => [AllOptions, ...buyersOptions]);
  }, [buyersOptions]);

  useEffect(() => {
    setLabelOptions((prevOptions) => [AllOptions, ...labelOpt]);
  }, [labelOpt]);

  useEffect(() => {
    setTypeOptions((prevOptions) => [AllOptions, ...typeOpt]);
  }, [typeOpt]);

  //***********FORM SUBMISSION ********//
  const onFormSubmit = (data) => {
    console.log("Filter Data-----------", data);
    const filterData = {
      status: data?.status,
      buyerName: data?.buyerName,
      label: data?.label,
      type: data?.type,
      // fromDate: data?.dateRange ? data?.dateRange[0]?.startDate : "",
      // toDate: data?.dateRange ? data?.dateRange[0]?.endDate : "",
      fromDate: data?.dateRange
        ? moment(selectedDateFilter?.startDate).startOf("day").toDate()
        : moment(data?.dateRange[0]?.startDate).startOf("day").toDate(),
      toDate: data?.dateRange
        ? moment(data?.dateRange[0]?.endDate).endOf("day").toDate()
        : new Date(),
    };

    dispatch(updateBuyersFilterData(filterData));
    setOpen(false);
  };

  // Call setFormValue after initialization
  useEffect(() => {
    if (previousFilterData && Object.keys(previousFilterData)?.length) {
      setFormValue(previousFilterData);
    }
  }, [previousFilterData]);

  // Set Form Value
  const setFormValue = (data) => {
    console.log("==----==================-----", data);

    const dateRange = {
      startDate: new Date(data?.fromDate),
      endDate: data?.toDate,
      key: "selection",
    };

    setValue("status", data?.status, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("buyerName", data?.buyerName, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("label", data?.label, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("type", data?.type, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("dateRange", dateRange, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <>
      <Drawer
        anchor={"right"}
        open={isOpen}
        onClose={() => setOpen(false)}
        sx={{
          [`& .MuiDrawer-paper`]: {
            boxSizing: "border-box",
            top: "15px",
            borderRadius: "16px",
            maxWidth: "500px",
            width: "100%",
          },
        }}
      >
        <Box
          sx={{
            pt: "1rem",
            pr: "1rem",
            pl: "1rem",
          }}
        >
          <Stack
            spacing={{ xs: 1, sm: 2 }}
            direction="row"
            useFlexGap
            flexWrap="wrap"
            justifyContent={"space-between"}
          >
            <Box marginBottom={"15px"}>
              <Typography component="h6" variant="h6" fontWeight={600}>
                Filters
              </Typography>
            </Box>
            <Box marginBottom={"15px"}>
              <Typography
                component="h7"
                variant="h7"
                fontWeight={200}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  dispatch(updateBuyersFilterData({}));
                  reset();
                }}
              >
                Clear All
              </Typography>
            </Box>
          </Stack>

          <Divider
            sx={{
              mb: "20px",
            }}
          />

          <Box component={"form"} className="accordionGrid">
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultBuyers == "status"
                  ? true
                  : defaultBuyers == "All"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">Status </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <GlobalDropdown
                  control={control}
                  size="small"
                  name="status"
                  options={statusOptions}
                  required
                  error={!!errors.status}
                  helperText={errors.status?.message}
                />
              </AccordionDetails>
            </Accordion>
            {/* <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultBuyers == "status"
                  ? true
                  : defaultBuyers == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Status{" "}
                  {AllFilterLength.status &&
                    AllFilterLength.status.length > 0 && (
                      <span className="count-style">
                        <p>{AllFilterLength.status.length}</p>
                      </span>
                    )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="status"
                  label=""
                  options={statusOptions || []}
                  required
                  error={!!errors.status}
                  helperText={errors.status?.message}
                />
              </AccordionDetails>
            </Accordion> */}
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultBuyers == "name"
                  ? true
                  : defaultBuyers == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Buyer{" "}
                  {AllFilterLength.buyerName &&
                    AllFilterLength.buyerName.length > 0 && (
                      <span className="count-style">
                        <p>{AllFilterLength.buyerName.length}</p>
                      </span>
                    )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                {/* <GlobalInput control={control} name="buyerName" label="" /> */}
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="buyerName"
                  label=""
                  options={BuyerOptions || []}
                  required
                  error={!!errors.buyerName}
                  helperText={errors.buyerName?.message}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultBuyers == "label"
                  ? true
                  : defaultBuyers == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Label{" "}
                  {AllFilterLength.label &&
                    AllFilterLength.label.length > 0 && (
                      <span className="count-style">
                        <p>{AllFilterLength.label.length}</p>
                      </span>
                    )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                {/* <GlobalDropdown control={control} name="label" options={[]} /> */}
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="label"
                  label=""
                  options={LabelOptions || []}
                  required
                  error={!!errors.label}
                  helperText={errors.label?.message}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultBuyers == "type"
                  ? true
                  : defaultBuyers == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Type{" "}
                  {AllFilterLength.type && AllFilterLength.type.length > 0 && (
                    <span className="count-style">
                      <p>{AllFilterLength.type.length}</p>
                    </span>
                  )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                {/* <GlobalDropdown control={control} name="type" options={[]} /> */}
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="type"
                  label=""
                  options={TypeOptions || []}
                  required
                  error={!!errors.type}
                  helperText={errors.type?.message}
                />
              </AccordionDetails>
            </Accordion>
            {/* </Grid> */}

            {/* <Grid item xs={12}> */}
            {/* <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultBuyers == "created"
                  ? true
                  : defaultBuyers == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">Create Date</Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <Controller
                  name="dateRange"
                  control={control}
                  render={({ field }) => (
                    <GlobalDateRangePicker
                      defaultRange={{
                        startDate: new Date(selectedDateFilter.fromDate),
                        endDate: new Date(selectedDateFilter.endDate),
                        key: "selection",
                      }}
                      {...field}
                    />
                  )}
                />
              </AccordionDetails>
            </Accordion> */}

            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultBuyers == "created"
                  ? true
                  : defaultBuyers == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">Create Date</Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <Controller
                  name="dateRange"
                  control={control}
                  render={({ field }) => (
                    <GlobalDateRangePicker
                      defaultRange={{
                        startDate: selectedDateFilter.startDate,
                        endDate: selectedDateFilter.endDate,
                      }}
                      {...field}
                    />
                  )}
                />
              </AccordionDetails>
            </Accordion>
          </Box>
        </Box>
        <Box
          sx={{
            pt: "1rem",
            pr: "1rem",
            pl: "1rem",
          }}
        >
          <Stack
            direction="row"
            component={Box}
            useFlexGap
            flexWrap="wrap"
            justifyContent={"flex-end"}
            bottom={0}
            marginTop={"1rem"}
          >
            <Box marginBottom={"15px"} marginRight={"5px"}>
              <CustomButton
                color="#3a5396"
                // label="Add Campaign"
                label="Apply Filter"
                onClick={handleSubmit(onFormSubmit)}
              />
            </Box>
            <Box marginBottom={"15px"}>
              <CustomButton
                labelColor="#7a7870"
                variant="outlined"
                color="white"
                label="Close"
                onClick={() => setOpen(false)}
              />
            </Box>
          </Stack>
        </Box>
      </Drawer>
    </>
  );
};

export default BuyerFilters;
